import { AssignmentInd as KundenIcon } from '@mui/icons-material';

import { AppFeature } from '../../components/dcbApp/types';

import { KundeListScreen } from './list/KundeListScreen';
import { KundeDialogForm } from './save/KundeDialogForm';
import { KundeViewScreen } from './view/KundeViewScreen';

export const kundeFeature: AppFeature = {
  path: 'kunde',
  label: 'Kunden',
  icon: <KundenIcon sx={{ color: 'secondary.main' }} />,
  list: <KundeListScreen />,
  view: <KundeViewScreen />,
  dialogs: [<KundeDialogForm />],
};
